import { useTranslation } from 'react-i18next';

import similarDresses from '../../../assets/similar-dresses.png';

export function ProductsNavigated() {
  const { t } = useTranslation();

  return (
    <div className="w-full rounded-lg border border-gray-200 bg-white p-5 md:w-1/2">
      <h3 className="mb-3 text-lg font-semibold">
        {t(
          'pages.Personalization.components.SimilarProducts.components.ProductNavigated.title',
        )}
      </h3>
      <p className="mb-4 text-sm text-gray-600">
        {t(
          'pages.Personalization.components.SimilarProducts.components.ProductNavigated.description',
        )}
      </p>

      <div className="relative w-full overflow-hidden rounded-md bg-gray-100">
        <img
          src={similarDresses}
          alt="Navigated dresses"
          className="mx-auto rounded-lg"
        />
      </div>
    </div>
  );
}
